import { omit } from 'lodash';
/**
 * Represents the map of all payment providers we've ever supported.
 *
 * @example
 * const status = metaVulnReportPaymentProcessor[paymentProvider?.paymentProcessor]?.displayName;
 */
export const metaVulnReportPaymentEveryProcessor = {
    Unknown: { value: '0', displayName: 'Unknown', order: 999 },
    MicrosoftPaymentCentral: {
        value: '561410000',
        displayName: 'Microsoft Payment Central',
        order: 90,
    },
    Bugcrowd: { value: '561410001', displayName: 'Bugcrowd', order: 2 },
    HackerOne: { value: '561410002', displayName: 'HackerOne', order: 3 },
    Intigriti: { value: '561410003', displayName: 'Intigriti', order: 1 },
};
/**
 * All possible payment processors that have existed (ever).
 */
export const EveryPaymentProcessor = {
    Unknown: 'Unknown',
    MicrosoftPaymentCentral: 'MicrosoftPaymentCentral',
    HackerOne: 'HackerOne',
    Intigriti: 'Intigriti',
    Bugcrowd: 'Bugcrowd',
};
/**
 * Payment processors that are currently disabled.
 */
export const disabledPaymentProcessorKey = [
    EveryPaymentProcessor.Bugcrowd,
    EveryPaymentProcessor.HackerOne,
    EveryPaymentProcessor.MicrosoftPaymentCentral,
];
/**
 * Payment processors that are currently enabled.
 */
export const PaymentProcessorEnabled = omit(EveryPaymentProcessor, disabledPaymentProcessorKey);
/**
 * Represents the map of different payment processors we currently support.
 *
 * @example
 * const status = metaVulnReportPaymentProcessor[paymentProvider?.paymentProcessor]?.displayName;
 */
export const metaVulnReportPaymentProcessor = omit(metaVulnReportPaymentEveryProcessor, disabledPaymentProcessorKey);
